export default function slugify(text) {
  return text
    .toString()                   // Convert to string
    .normalize('NFD')             // Normalize to decompose accents
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .toLowerCase()                // Convert to lowercase
    .trim()                       // Remove leading and trailing whitespace
    .replace(/&/g, 'and')         // Replace & with and
    .replace(/[^a-z0-9 -]/g, '')  // Remove invalid characters
    .replace(/\s+/g, '-')         // Replace spaces with -
    .replace(/-+/g, '-');         // Replace multiple - with single -
}